/**
 * Nautilus OS - ERP Marítimo
 * @version 0.2.0
 * @build 2026-02-25-v2
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Build version marker
// NautilusOS v3.42.1

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
